import { ROOT_TEST_ID, SLOT_TEST_ID } from '../constants';

interface IBuildBalloonTemplateParams {
  slotId: string;
  rootClassName: string;
  transform: string;
  previewWidth: number;
}

export function buildBalloonTemplate({
  slotId,
  rootClassName,
  transform,
  previewWidth,
}: IBuildBalloonTemplateParams): string {
  // --preview-width наследуется по DOM в карточку (.card_desktop) внутри слота балуна.
  const rootStyle = `transform: ${transform}; --preview-width: ${previewWidth}px`;

  return `
    <div data-testid="${ROOT_TEST_ID}" class="${rootClassName}" style="${rootStyle}">
      <div id="${slotId}" data-testid="${SLOT_TEST_ID}"></div>
    </div>
  `;
}
